// extracted by mini-css-extract-plugin
export var carrierNotice = "_kk-5";
export var carrierNoticePlaceholder = "_kk-6";
export var deliveryRow = "_kk-c";
export var fixedHeight = "_kk-4";
export var freightLogo = "_kk-b";
export var fullWidth = "_kk-3";
export var priceColumn = "_kk-7";
export var radioSelected = "_kk-9";
export var radioUnselected = "_kk-8";
export var selectedOption = "_kk-2";
export var selectedOptionContainer = "_kk-1";
export var selection = "_kk-0";
export var tallSkeletonText = "_kk-a";